/**
 * Import app.scss
 */

import './sass/app.scss';

import PropertySearchContainer from "./vue/PropertySearchModule/PropertySearchContainer";
import VueRouter from 'vue-router';
import {initRouter} from "./config/initConfiguration";
import {Engine} from '@milestoneslabs/milestones-core-js';

/**
 * @param {VueRouter} vueRouter
 */
export function configureRouter(vueRouter, routesConfig) {
    return initRouter(vueRouter, routesConfig);
}

export function configureEngine(rawConfig) {
    Engine.config(rawConfig);
}

let store = null;
export function configureStore(storeObj) {
    store = storeObj;
}
export {store};

let events = null;
export function configureEvents(eventsObj) {
    events = eventsObj;
}
export {events};

export default PropertySearchContainer;
